/** @format */
import {AccountsKpiName} from 'graphql/generated/types';

import {
  GetAnalyticGoalsQueryPage,
  GetCompanyMediaplansQueryPage,
  GetCurrentUserQueryPage,
} from './graphql/__generated__';

export type ControlsPeriod = 'year' | 'quarter' | 'half-year';
export type PeriodType = 'repeatable' | 'flight';
export type PeriodRepeatEveryType = 'weekly' | 'monthly';

export enum YalperAnalyticAttributionModelEnum {
  AUTOMATIC = 'AUTOMATIC',
  CROSS_DEVICE_FIRST = 'CROSS_DEVICE_FIRST',
  CROSS_DEVICE_LAST = 'CROSS_DEVICE_LAST',
  CROSS_DEVICE_LAST_SIGNIFICANT = 'CROSS_DEVICE_LAST_SIGNIFICANT',
  CROSS_DEVICE_LAST_YANDEX_DIRECT_CLICK = 'CROSS_DEVICE_LAST_YANDEX_DIRECT_CLICK',
  FIRST = 'FIRST',
  LAST = 'LAST',
  LAST_YANDEX_DIRECT_CLICK = 'LAST_YANDEX_DIRECT_CLICK',
  LASTSIGN = 'LASTSIGN',
}

export interface Period {
  id: string;
  startDate: Date | null;
  endDate: Date | null;
  type: PeriodType;
  repeatEvery: PeriodRepeatEveryType;
  isLinkedWithPeriodStart: boolean;
  budgetPlan: number | null;
  kpis?: KpiLocalSettings[];
  primaryKpiId?: string | null;
}

export interface KPI {
  name: AccountsKpiName;
  primary: boolean;
  value: number | null;
}

export interface KpiLocalSettings extends KPI {
  id: AccountsKpiName;
  description?: string;
  needsMetricGoals?: boolean;
}

export interface KPIConfig {
  id: AccountsKpiName;
  name: string;
  description?: string;
  needsMetricGoals?: boolean;
}

export type CompanyMediaplanFromQuery = NonNullable<
  NonNullable<GetCompanyMediaplansQueryPage['currentUser']>['company']
>['mediaplans'][number];

export type KpiSettingsFromQuery = NonNullable<
  NonNullable<GetCurrentUserQueryPage['currentUser']>['company']
>['kpiSettings'];

export type AnalyticGoalFromQuery = NonNullable<
  NonNullable<GetAnalyticGoalsQueryPage['currentUser']>['company']
>['analyticGoals'][number];

export type TokensFromQuery = NonNullable<
  NonNullable<GetCurrentUserQueryPage['currentUser']>['company']
>['tokens'];
